module.exports = __webpack_public_path__ + "media/luxury-2026/lake-top-down-960-2f1ae808.jpg";